import { getUtilityClasses } from "./styles";
export const menuBarClasses = getUtilityClasses("MenuBar", [
    "root",
    "sticky",
    "nonSticky",
    "content",
]);
